export default "__VITE_ASSET__bVYz2X8$__"